var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Morning"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4200",
    x: 0.5,
    y: 0.5,
    width: 27.3625,
    height: 20.78,
    rx: 5.5,
    fill: "#F5F5F5",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M18.7591 5.965V15H17.2771V8.812L14.5211 15H13.4941L10.7251 8.812V15H9.24307V5.965H10.8421L14.0141 13.05L17.1731 5.965H18.7591Z",
    fill: "#233849"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorning);
export default __webpack_public_path__ + "static/media/Morning.75b59d39a17443ade4fc48c77c1c6063.svg";
export { ForwardRef as ReactComponent };